/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field, Form, Formik, useFormikContext } from "formik";
import React, { useEffect } from "react";
import Layout from "../../../../components/Layout/DashboardLayout";
import style from "./index.module.scss";
import { useSelector, useDispatch } from "react-redux";
import {
  CreatePhonebookSchema,
  UploadPhonebookSchema,
} from "../../../../utils/ValidationSchemas";
import Button from "../../../../components/Button";
import { FormRowRadio } from "../../../../components/Form-row";
import * as phonebookActions from "../../../../redux/actions/createPhonebookActions";
import { clearErrorMessage } from "../../../../redux/actions/messageActions";
import { css } from "@emotion/react";
import { ScaleLoader } from "react-spinners";
import { useLocation, useNavigate } from "react-router-dom";
import Dialog from "../../../../components/Dialog";
import FileUpload from "../../../../components/FIleUpload";
import axios from "axios";
import { apiErrorHandler } from "../../../../utils/apiErrorHandler";
import TagInput from "../../../../components/TagInput";

const ContactCreateType = () => {
  const { values } = useFormikContext();
  return (
    <>
      <div className={style["radio--buttons"]}>
        <FormRowRadio>
          <Field
            type="radio"
            name="type"
            value="single"
            checked={values.type === "single"}
            id="single"
          />
          <label htmlFor="single">Single Contact</label>
        </FormRowRadio>

        <FormRowRadio>
          <Field
            type="radio"
            name="type"
            value="batch"
            checked={values.type === "batch"}
            id="batch"
          />
          <label htmlFor="batch">Batch Contact</label>
        </FormRowRadio>
      </div>
    </>
  );
};

const CreatePhonebookForm = ({ openUploadDialog }) => {
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.auth.authState);
  const isSending = useSelector((state) => state.creatingPhonebook.isSending);
  const notification = useSelector((state) => state.message);
  const [phoneNumbers, setPhoneNumber] = React.useState([]);
  const dispatch = useDispatch();
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: white;
    baground-color: white;
  `;

  const initialValues = {
    type: "single",
    name: "",
    msisdns: "",
    msisdns_file: "",
    contact_name: "",
    client_id: userInfo?.key?.client_id,
    token: userInfo?.token,
  };

  const handleToggle = (props) => {
    props.resetForm();
    dispatch(clearErrorMessage());
  };

  return (
    <div>
      <h3>Create Phonebook</h3>
      <p>Please enter the following details.</p>

      <ul className="signup__errors">
        {notification.error && !openUploadDialog && (
          <li>{apiErrorHandler(notification?.msg.error)}</li>
        )}
      </ul>

      <Formik
        initialValues={initialValues}
        validationSchema={CreatePhonebookSchema}
        onSubmit={(values, actions) => {
          const formData = new FormData();
          formData.append("name", values.name);

          // if (values.type === "batch") {
          //   const divisor = values.msisdns.length / 13;
          //   const remainder = values.msisdns.length % 13;
          //   if (remainder > 0) {
          //     return;
          //   }
          //   let newNumbers = "";
          //   for (let i = 0; i < divisor; i++) {
          //     const init = i === 0 ? 0 : i * 13;
          //     const singleNumber = values.msisdns.substr(init, 13);
          //     newNumbers =
          //       newNumbers + `${singleNumber}${i < divisor - 1 ? "," : ""}`;
          //   }
          //   console.log(newNumbers);
          //   formData.append("msisdns", newNumbers);
          // }

          formData.append("client_id", values.client_id);
          formData.append("token", values.token);
          if (values.message_file) {
            formData.append("msisdns_file", values.msisdns_file);
          }

          if (values.type === "single") {
            formData.append("contact_name", values.contact_name);
            formData.append("msisdns", values.msisdns);
          }
          if (values.type === "batch") {
            formData.append("msisdns", phoneNumbers.toString());
          }

          dispatch(phonebookActions.createSingleOrBatchPhonebook(formData));
        }}
      >
        {({ values, setFieldValue, ...props }) => (
          <Form>
            <div className={style["form__group"]}>
              <label htmlFor="name">Phonebook Name </label>

              <Field id="name" name="name" placeholder="Raah Cosmetics" />

              <ErrorMessage name="name" className="error" component="span" />
            </div>
            <ContactCreateType />
            {values.type === "single" ? (
              <p style={{ color: "#000000" }}>
                Create individual contacts.(you can add more later.)
              </p>
            ) : (
              <ol className={style["requirement--list"]}>
                <li>
                  Save multiple contacts at the same time in this format
                  <br /> +2349090866286, +2349020528104 e.t.c.
                </li>
              </ol>
            )}
            {values.type === "single" && (
              <div className={style["form__group"]}>
                <label htmlFor="contact_name">Customer Name </label>

                <Field
                  id="contact_name"
                  name="contact_name"
                  placeholder="Raah Cosmetics"
                />

                <ErrorMessage
                  name="contact_name"
                  className="error"
                  component="span"
                />
              </div>
            )}
            <div className={style["form__group"]}>
              <label htmlFor="msisdns">Customer Phone number </label>
              {values.type === "single" ? (
                <TextArea
                  id="msisdns"
                  name="msisdns"
                  placeholder="+2349090866286"
                />
              ) : (
                <TagInput
                  tagInputs={phoneNumbers}
                  setTagInputs={setPhoneNumber}
                  name="msisdns"
                  inputType={"number"}
                  placeholder={"+2349090866286,+2349020528104,..."}
                />
              )}
              {/* <span>{values.msisdns.length / 13}</span> */}
              <ErrorMessage name="msisdns" className="error" component="span" />
            </div>
            {phoneNumbers.length === 0 && values.type === "batch" && (
              <p
                className="error"
                style={{
                  color: "red",
                }}
              >
                Please enter phone number(s).
              </p>
            )}
            {/* <textarea placeholder="+2349090866286"></textarea> */}
            <Button
              type="submit"
              className="filled"
              disabled={
                isSending ||
                (phoneNumbers.length === 0 && values.type === "batch")
              }
            >
              {!isSending ? (
                " Save"
              ) : (
                <ScaleLoader
                  css={override}
                  size={80}
                  color={"#fff"}
                  loading={true}
                />
              )}
            </Button>

            <Dialog
              isOpen={notification.success}
              toggleModal={() => handleToggle(props)}
            >
              {/* <img src={doubleTickIcon} alt="doubleTickIcon" /> */}
              <h3>Contact Saved Successfully </h3>
              <p>you can add others to this phone book.</p>
              <div style={{ display: "flex", gap: "2rem" }}>
                <Button
                  className="medium--filled"
                  onClick={() => handleToggle(props)}
                >
                  Create Another Phonebook
                </Button>
                <Button
                  className="medium--ghost"
                  onClick={() => {
                    dispatch(clearErrorMessage());
                    navigate("/user/phonebook");
                  }}
                >
                  View all contact
                </Button>
              </div>
            </Dialog>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const UpdatePhonebookForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.pathname.split("/")[4];
  const name = location.pathname.split("/")[5];
  const total = location.pathname.split("/")[6];
  const userInfo = useSelector((state) => state.auth.authState);

  const isSending = useSelector((state) => state.creatingPhonebook.isSending);
  const notification = useSelector((state) => state.message);
  const [phonebookDetails, setPhonebookDetails] = React.useState();
  const [numbers, setNumbers] = React.useState([]);
  useEffect(() => {
    const getPhonebookDetails = async () => {
      try {
        let response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/phonebook/dev/client/${id}/items`,
          {
            client_id: userInfo.id,
            token: userInfo.token,
          }
        );

        if (response.status === 200) {
          setPhonebookDetails(response?.data);
          let numbers = response.data?.data.map((item) => item.msisdn);

          setNumbers(numbers);
        } else {
          setPhonebookDetails(response?.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getPhonebookDetails();
  }, []);

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: white;
    baground-color: white;
  `;
  return (
    <div>
      <h3>Edit Phonebook</h3>
      <p>Please enter the following details. </p>
      <Formik
        initialValues={{
          type: total >= 2 ? "batch" : "single",
          name: "",
          msisdns: "",
          client_id: userInfo?.key?.client_id,
          token: userInfo.token,
          contact_name: "",
        }}
        onSubmit={(values) => {
          const formData = new FormData();
          formData.append("name", values.name || name);

          formData.append("client_id", values.client_id);
          formData.append("token", values.token);
          if (values.type === "single") {
            formData.append("contact_name", values.contact_name);
            formData.append("msisdns", values.msisdns);
          }

          if (values.type === "batch") {
            formData.append("msisdns", numbers.toString());
          }

          dispatch(phonebookActions.updateSingleOrBatchPhonebook(formData, id));
        }}
      >
        {({ values, ...props }) => (
          <Form>
            <div>
              <label htmlFor="name">Phonebook Name </label>
              <input
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                defaultValue={`${name}`}
                name="name"
              />
            </div>
            <ContactCreateType />
            {values.type === "single" ? (
              <p style={{ color: "#000000" }}>
                Create individual contacts.(you can add more later.)
              </p>
            ) : (
              <ol className={style["requirement--list"]}>
                <li>
                  Save multiple contacts at the same time in this format
                  <br /> +2349090866286, +2349020528104 e.t.c.
                </li>
              </ol>
            )}

            {values.type === "single" && (
              <div className={style["form__group"]}>
                <label htmlFor="contact_name">Customer Name </label>
                <input
                  type="text"
                  id="contact_name"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  name="contact_name"
                  placeholder="Raah Cosmetics"
                  defaultValue={phonebookDetails?.data?.map(
                    (item) => item.name
                  )}
                />
              </div>
            )}

            <div className={style["form__group"]}>
              <label htmlFor="msisdns">Customer Phone number </label>
              {values.type === "single" ? (
                <textarea
                  style={{ height: "150px" }}
                  name="msisdns"
                  id="msisdns"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  defaultValue={phonebookDetails?.data?.map(
                    (item) => item.msisdn
                  )}
                ></textarea>
              ) : (
                <TagInput tagInputs={numbers} setTagInputs={setNumbers} />
              )}
            </div>
            <Button type="submit" className="filled" disabled={isSending}>
              {!isSending ? (
                " Update"
              ) : (
                <ScaleLoader
                  css={override}
                  size={80}
                  color={"#fff"}
                  loading={true}
                />
              )}
            </Button>

            <Dialog isOpen={notification.success}>
              {/* <img src={doubleTickIcon} alt="doubleTickIcon" /> */}
              <h3>Contact updated Successfully </h3>
              <div style={{ display: "flex", gap: "2rem" }}>
                <Button
                  className="small--filled"
                  onClick={() => {
                    dispatch(clearErrorMessage());
                    navigate(`/user/phonebooks/${id}/${name}`);
                  }}
                >
                  View all contact
                </Button>
              </div>
            </Dialog>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const AddPhonebookForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.pathname.split("/")[4];
  const name = location.pathname.split("/")[5];
  const total = location.pathname.split("/")[6];
  const userInfo = useSelector((state) => state.auth.authState);

  const isSending = useSelector((state) => state.creatingPhonebook.isSending);
  const notification = useSelector((state) => state.message);
  const [setPhonebookDetails] = React.useState();

  useEffect(() => {
    const getPhonebookDetails = async () => {
      try {
        let response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/phonebook/dev/client/${id}/items`,
          {
            client_id: userInfo.id,
            token: userInfo.token,
          }
        );

        if (response.status === 200) {
          setPhonebookDetails(response?.data);
        } else {
          setPhonebookDetails(response?.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getPhonebookDetails();
  }, []);

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: white;
    baground-color: white;
  `;
  return (
    <div>
      <h3>Add to {name}'s Phonebook</h3>
      <p>Please enter the following details. </p>
      <Formik
        initialValues={{
          type: total >= 2 ? "batch" : "single",
          name: "",
          msisdns: "",
          client_id: userInfo?.key?.client_id,
          token: userInfo.token,
          contact_name: "",
        }}
        onSubmit={(values) => {
          const formData = new FormData();
          formData.append("name", values.name || name);
          formData.append("msisdns", values.msisdns);
          formData.append("client_id", values.client_id);
          formData.append("token", values.token);
          if (values.type === "single") {
            formData.append("contact_name", values.contact_name);
          }

          dispatch(phonebookActions.updateSingleOrBatchPhonebook(formData, id));
        }}
      >
        {({ values, ...props }) => (
          <Form>
            <div>
              <label htmlFor="name">Phonebook Name </label>
              <input
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                defaultValue={`${name}`}
                name="name"
              />
            </div>
            <ContactCreateType />
            {values.type === "single" ? (
              <p style={{ color: "#000000" }}>
                Create individual contacts.(you can add more later.)
              </p>
            ) : (
              <ol className={style["requirement--list"]}>
                <li>
                  Save multiple contacts at the same time in this format
                  <br /> +2349090866286, +2349020528104 e.t.c.
                </li>
              </ol>
            )}

            {values.type === "single" && (
              <div className={style["form__group"]}>
                <label htmlFor="contact_name">Customer Name </label>
                <input
                  type="text"
                  id="contact_name"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  name="contact_name"
                  placeholder="Raah Cosmetics"
                  // defaultValue={phonebookDetails?.data?.map(
                  //   (item) => item.name
                  // )}
                />
              </div>
            )}

            <div className={style["form__group"]}>
              <label htmlFor="msisdns">Customer Phone number </label>
              <textarea
                style={{ height: "150px" }}
                name="msisdns"
                id="msisdns"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                // defaultValue={phonebookDetails?.data?.map(
                //   (item) => item.msisdn
                // )}
              ></textarea>
            </div>
            <Button type="submit" className="filled" disabled={isSending}>
              {!isSending ? (
                " Add"
              ) : (
                <ScaleLoader
                  css={override}
                  size={80}
                  color={"#fff"}
                  loading={true}
                />
              )}
            </Button>

            <Dialog isOpen={notification.success}>
              {/* <img src={doubleTickIcon} alt="doubleTickIcon" /> */}
              <h3>Contact updated Successfully </h3>
              <div style={{ display: "flex", gap: "2rem" }}>
                <Button
                  className="small--filled"
                  onClick={() => {
                    dispatch(clearErrorMessage());
                    navigate("/user/phonebook");
                  }}
                >
                  View all contact
                </Button>
              </div>
            </Dialog>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const CreatePhonebook = () => {
  const [openUploadDialog, setOpenUploadDialog] = React.useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const actionType = location.pathname.split("/")[3];
  const id = location.pathname.split("/")[4];
  const isSending = useSelector((state) => state.creatingPhonebook.isSending);
  const userInfo = useSelector((state) => state.auth.authState);
  const notification = useSelector((state) => state.message);
  const handleUploadCSV = () => {
    setOpenUploadDialog(true);
    dispatch(clearErrorMessage());
  };

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: white;
    baground-color: white;
  `;
  const initialValues = {
    name: "",
    msisdns: "",
    msisdns_file: "",
    client_id: userInfo?.key?.client_id,
    token: userInfo?.token,
  };
  return (
    <Layout pageTitle={`${id ? "Edit" : "Create"} Phonebook`}>
      <div
        style={{
          padding: "2rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "baseline",
          color: "red",
        }}
      >
        <a href="/user/phonebook" className={style["back"]}>
          {" "}
          <span>
            <svg
              width="20"
              height="16"
              viewBox="0 0 20 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 15L1 8M1 8L8 1M1 8L19 8"
                stroke="#EB2931"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>{" "}
          <span> Back</span>
        </a>
        <div className={style["container"]}>
          <div className={style["form--section"]}>
            {id && actionType === "edit" ? (
              <UpdatePhonebookForm />
            ) : id && actionType === "add" ? (
              <AddPhonebookForm />
            ) : (
              <CreatePhonebookForm {...{ openUploadDialog }} />
            )}
          </div>
          <div className={style["upload--section"]}>
            <Button
              className="small--filled"
              type="submit"
              onClick={handleUploadCSV}
              style={{ width: "230px" }}
            >
              <span>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    style={{ fill: "transparent" }}
                    d="M6.00007 15C5.01509 15.0011 4.06433 14.6388 3.32994 13.9823C2.59556 13.3259 2.12919 12.4216 2.02018 11.4427C1.91118 10.4638 2.1672 9.47902 2.73921 8.67714C3.31121 7.87526 4.15897 7.31263 5.12007 7.09703C4.84199 5.80012 5.0905 4.44586 5.81092 3.33218C6.53134 2.21849 7.66467 1.43661 8.96157 1.15853C10.2585 0.880448 11.6127 1.12895 12.7264 1.84937C13.8401 2.56979 14.622 3.70312 14.9001 5.00003H15.0001C16.24 4.99878 17.4362 5.45831 18.3564 6.2894C19.2766 7.12049 19.8552 8.26386 19.9798 9.49753C20.1044 10.7312 19.7662 11.9672 19.0308 12.9655C18.2954 13.9638 17.2152 14.6533 16.0001 14.9M14.0001 12L11.0001 9.00003M11.0001 9.00003L8.00007 12M11.0001 9.00003V21"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>{" "}
              Upload Contacts
            </Button>
            <Dialog isOpen={openUploadDialog}>
              <div className={style["upload--dialog"]}>
                <p
                  onClick={() => {
                    setOpenUploadDialog(!openUploadDialog);
                    dispatch(clearErrorMessage());
                  }}
                >
                  {" "}
                  <span>
                    <svg
                      width="20"
                      height="16"
                      viewBox="0 0 20 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 15L1 8M1 8L8 1M1 8L19 8"
                        stroke="#EB2931"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>{" "}
                  <span> Back</span>
                </p>
                <ul className="signup__errors">
                  {notification.error && openUploadDialog && (
                    <li>{apiErrorHandler(notification?.msg.error)}</li>
                  )}
                </ul>
                <h3 className={style["title"]}>Upload Contacts</h3>
                <p className={style["info"]}>
                  Upload format(Select a CSV File, Each line should
                  <br /> contain Phone number and Name)
                </p>

                <div className={style["download"]}>
                  <a href="https://res.cloudinary.com/face-aging-api/raw/upload/v1637052118/contact_to_upload_format.csv">
                    <p>Download Format </p>
                    <span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          style={{ fill: "transparent" }}
                          d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                          stroke="#1586D8"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          style={{ fill: "transparent" }}
                          d="M7 10L12 15L17 10"
                          stroke="#1586D8"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          style={{ fill: "transparent" }}
                          d="M12 15V3"
                          stroke="#1586D8"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
                <Formik
                  initialValues={initialValues}
                  validationSchema={UploadPhonebookSchema}
                  onSubmit={async (values) => {
                    const formData = new FormData();
                    formData.append("name", values.name);
                    formData.append("client_id", values.client_id);
                    formData.append("token", values.token);

                    formData.append("msisdns_file", values.msisdns_file);

                    await dispatch(
                      phonebookActions.createSingleOrBatchPhonebook(formData)
                    );
                  }}
                >
                  {({ values, setFieldValue, ...props }) => (
                    <Form>
                      <div className={style["upload--form"]}>
                        <FileUpload
                          setFieldValue={setFieldValue}
                          values={values}
                          name="msisdns_file"
                          accept=".csv, .txt"
                        >
                          <span>
                            <svg
                              width="50"
                              height="50"
                              viewBox="0 0 32 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M29.6475 12.9787H28.8V8.88995C28.7993 8.86397 28.7968 8.83808 28.7925 8.81245C28.7937 8.64819 28.735 8.48913 28.6275 8.36495L21.825 0.593701L21.82 0.588701C21.7792 0.544693 21.733 0.50605 21.6825 0.473701L21.6375 0.446201C21.5943 0.422173 21.5486 0.402894 21.5012 0.388701L21.4638 0.376201C21.4118 0.363252 21.3585 0.356538 21.305 0.356201H4.58375C3.82 0.356201 3.2 0.977451 3.2 1.73995V12.9775H2.3525C1.26 12.9775 0.375 13.8624 0.375 14.9549V25.2399C0.375 26.3312 1.26125 27.2174 2.3525 27.2174H3.2V34.2575C3.2 35.0199 3.82 35.6412 4.58375 35.6412H27.4162C28.1787 35.6412 28.8 35.0199 28.8 34.2575V27.2174H29.6475C30.7387 27.2174 31.625 26.3324 31.625 25.2399V14.9549C31.625 13.8637 30.74 12.9787 29.6475 12.9787ZM4.58375 1.73995H20.6125V8.81995C20.6125 9.20245 20.9225 9.5112 21.305 9.5112H27.4175V12.9775H4.58375V1.73995ZM14.9363 20.6999C13.2563 20.0999 12.1475 19.1699 12.1475 17.7012C12.1475 15.9774 13.6025 14.6737 15.9712 14.6737C17.1262 14.6737 17.95 14.8987 18.55 15.1825L18.04 17.0112C17.3864 16.6929 16.6683 16.5291 15.9412 16.5324C14.9512 16.5324 14.4713 16.9962 14.4713 17.5062C14.4713 18.1512 15.025 18.4349 16.345 18.9299C18.13 19.5899 18.9538 20.5187 18.9538 21.9437C18.9538 23.6387 17.665 25.0774 14.8913 25.0774C13.7363 25.0774 12.5975 24.7624 12.0275 24.4475L12.4925 22.5737C13.2774 22.9745 14.1438 23.19 15.025 23.2037C16.075 23.2037 16.63 22.7675 16.63 22.1087C16.63 21.4787 16.1512 21.1199 14.9363 20.6999ZM3.02875 20.0099C3.02875 16.5762 5.4875 14.6724 8.545 14.6724C9.73 14.6724 10.6288 14.9112 11.0338 15.1075L10.5537 16.9212C9.94656 16.6662 9.2935 16.5386 8.635 16.5462C6.83625 16.5462 5.4275 17.6399 5.4275 19.8887C5.4275 21.8974 6.62625 23.1724 8.65 23.1724C9.355 23.1724 10.105 23.0387 10.5687 22.8424L10.9 24.6412C10.495 24.8349 9.535 25.0762 8.32125 25.0762C4.8275 25.0774 3.02875 22.8887 3.02875 20.0099ZM27.4162 33.8849H4.58375V27.2187H27.4162V33.8849ZM25.5688 24.9274H22.9L19.6625 14.8224H22.1663L23.395 19.0962C23.7388 20.3099 24.0538 21.4499 24.2938 22.7087H24.3387C24.5943 21.5075 24.8992 20.3174 25.2525 19.1412L26.5425 14.8237H28.97L25.5688 24.9274Z"
                                fill="#828282"
                              />
                            </svg>
                          </span>
                          <p className={style["filename"]}>
                            {values.msisdns_file?.name}
                          </p>
                        </FileUpload>
                        <ErrorMessage
                          className="error"
                          name="msisdns_file"
                          component="span"
                        />
                      </div>

                      <div className={style["form__group"]}>
                        <label htmlFor="name">Phonebook Name </label>
                        <Field
                          id="name"
                          name="name"
                          placeholder="Raah Cosmetics"
                        />
                        <ErrorMessage
                          className="error"
                          name="name"
                          component="span"
                        />
                      </div>
                      <Button
                        className="filled"
                        type="submit"
                        disabled={isSending}
                      >
                        {isSending ? (
                          <ScaleLoader
                            css={override}
                            size={80}
                            color={"#fff"}
                            loading={true}
                          />
                        ) : (
                          "Upload"
                        )}
                      </Button>
                    </Form>
                  )}
                </Formik>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </Layout>
  );
};

const TextArea = ({ name, placeholder, children, ...props }) => {
  return (
    <>
      <Field as="textarea" {...props} name={name} placeholder={placeholder} />
      {children}
    </>
  );
};
export default CreatePhonebook;
